import { lazy, Suspense, useState } from 'react';
import { useT } from '../i18n/i18n';

const DataFlowMap = lazy(() => import('./DataFlowMap'));

export default function WhereButton({ ids, url }: { ids?: (string | null | undefined)[]; url?: string }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const real = (ids ?? []).filter((x): x is string => !!x);
  const target = url ?? (real.length ? `/ai/flow?${real.map((i) => `ids=${encodeURIComponent(i)}`).join('&')}` : null);
  if (!target) return null;
  return (
    <>
      <button type="button" className="btn ghost flow-open" onClick={() => setOpen(true)}>{t('Where did my data go?')}</button>
      {open && (
        <Suspense fallback={null}>
          <DataFlowMap url={target} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
